import React, { Component } from 'react';
import { Link , Redirect } from 'react-router-dom';
import autobind from 'react-autobind'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'

import _ from 'lodash'
import moment from 'moment'
import { Navbar, NavbarToggler, Collapse, Nav, NavItem, DropdownMenu, Dropdown, DropdownToggle, DropdownItem } from 'reactstrap';
import StatusBar from './../Status/StatusBar'

class Header extends Component {

  constructor(props) {
    super(props);
    autobind(this);

    this.state = {
      navbarOpen: false,
      productsDropdownOpen: false,
      userDropdownOpen: false,
      userNotifications: false,
      storiesDropdownOpen: false,

      // modules
      furnitureDropdownOpen: false,
      homeDecoDropdownOpen: false,
      realEstateDropdownOpen: false,
      notificationsDropdownOpen: false,
    };
  }

  componentDidMount() {
    this.props.getUserNotifications()
  }

  onLogoutClick() {
    this.props.logout(this.props.impersonating);
  }

  toggleUserNotifications() {
    this.setState({
      userNotifications: !this.state.userNotifications
    })
  }

  getSubscriptionByDomainConstantCanUpload(constant) {
    const subscriptions = _.filter(this.props.subscriptions, (subscription) => subscription.domain.constant === constant)

    if (subscriptions.length) {
      return subscriptions[0].canUpload
    }

    return false
  }

  subscriptionAvailableByDomainConstant(constant) {
    const subscription = _.find(this.props.subscriptions, (subscription) => subscription.domain.constant === constant)
    return subscription
  }


  toggle(target) {
    switch (target) {
      case 'products':
        this.setState({
          productsDropdownOpen: !this.state.productsDropdownOpen,
        });
        break;
      case 'stories':
        this.setState({
          storiesDropdownOpen: !this.state.storiesDropdownOpen,
        })
        break;
      case 'furniture':
        this.setState({
          furnitureDropdownOpen: !this.state.furnitureDropdownOpen,
        })
        break;

      case 'home_deco':
        this.setState({
          homeDecoDropdownOpen: !this.state.homeDecoDropdownOpen,
        })
        break;

      case 'real_estate':
        this.setState({
          realEstateDropdownOpen: !this.state.realEstateDropdownOpen,
        })
        break;

      case 'notifications':
        this.setState({
          notificationsDropdownOpen: !this.state.notificationsDropdownOpen,
        })
        break;

      case 'user':
        this.setState({
          userDropdownOpen: !this.state.userDropdownOpen
        });
        break;

      case 'navbar':
        this.setState({
          navbarOpen: !this.state.isNavbarOpen
        })
        break;

      default: break;
    }
  }

  render() {
    const { user, role, userNotifications } = this.props;

    // when impersonate ends
    if (role === 3) {
      return <Redirect to="/s/dashboard" />
    }

    if (!user) {
      return <Redirect to="/login" />
    }

    return (
      <div>
        <Navbar className="mai-top-header navbar navbar-expand-md navbar-dark bg-faded">
          <div className="container">
            <Link to="/stories" className="navbar-brand" />
            <NavbarToggler />
            <Collapse isOpen={this.state.navbarOpen} navbar>
              <Nav className="ml-auto nav mai-top-nav" navbar>
                <NavItem>
                  <Link to="/stories" className="nav-link">Storyboard</Link>
                </NavItem>
                <NavItem>
                  <Link to="/products" className="nav-link">Product Gallery</Link>
                </NavItem>
                <NavItem>
                  <Link to="/statistics" className="nav-link">Statistics</Link>
                </NavItem>
                <NavItem>
                    <Link to="/messages" className="nav-link">Messages</Link>
                  </NavItem>
              </Nav>
              <ul className="navbar-nav float-lg-right mai-icons-nav">
                <li onClick={this.toggleUserNotifications} className={`dropdown nav-item mai-notifications ${  this.state.userNotifications ? 'show' : ''}`}>
<a href="" onClick={(e) => { e.preventDefault() }} data-toggle="dropdown" role="button" aria-expanded="true" className="nav-link dropdown-toggle"><span className="icon s7-bell"></span>{userNotifications.length ? (<span className="indicator"></span>) : null}</a>
                  <ul className={`dropdown-menu ${  this.state.userNotifications ? 'show' : ''}`}>
                    <li>
                      <div className="title">Notifications</div>
                      <div className="mai-scroller ps-container ps-theme-default">
                        <div className="content">
                          <ul>
                            {userNotifications.length ? userNotifications.map((notification, index) => (
                                <li key={`${notification._id}-${index}`}>
                                  <Link to="messages">
                                    <div className="icon"><span className="s7-mail"></span></div>
                                    <div className="content">
                                      <span className="desc">{notification.message}.</span>
                                      <span className="date">{moment(notification.date).fromNow()}</span>
                                    </div>
                                  </Link>
                                </li>)) : (<div className="footer p-4">You have no notifications</div>)}
                          </ul>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
              <Nav className="nav float-lg-right mai-user-nav" navbar>
                <Dropdown nav isOpen={this.state.userDropdownOpen} toggle={() => this.toggle('user')} className="nav-item">
                  <DropdownToggle nav>
                    <img src={user.picturePath} alt="avatar" />
                    <span className="user-name pr-2">{user.username}</span>
                    <span className="angle-down s7-angle-down" />
                  </DropdownToggle>
                  <DropdownMenu>
                    <Link to="/my-account" className="dropdown-item">
<span className="icon s7-tools pr-2"> </span>
{' '}
My account
</Link>
                    <DropdownItem onClick={this.onLogoutClick}>
<span className="icon s7-power pr-2"> </span>
{' '}
Sign out
</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Nav>
            </Collapse>
          </div>
        </Navbar>
        <StatusBar />
      </div>
    );
  }

}

export default connect(
  (state, ownProps) => {
    const { auth: { user, error, loggingOut, impersonating, impersonateEnded, role }, userStatus: { subscriptions }, notifications: { userNotifications }, getCategories: { categoriesFurniture, categoriesRealEstate, categoriesHomeDeco } } = state
    return {
 user, error, loggingOut, impersonating, impersonateEnded, role, subscriptions, categoriesFurniture, userNotifications, categoriesRealEstate, categoriesHomeDeco 
}
  },
  actions,
  (stateProps, dispatchProps) => Object.assign({}, stateProps, dispatchProps)
)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/index.js